<div class="content">
  <h3 class="title">{{ title }}</h3>
  <div *ngIf="data?.showReasonField" class="content">
    <form class="formulario">
      <mat-form-field class="matform" appearance="outline" style="width:100%">
        <mat-label>Motivo de devolución / rechazo</mat-label>
        <textarea matInput [(ngModel)]="reason" name="reason" rows="4"></textarea>
      </mat-form-field>
    </form>
  </div>
  <div class="buttons">
    <button mat-raised-button (click)="close(false)" class="cancel-btn rounded">
      Cancelar
    </button>
    <button mat-raised-button (click)="close(true)" class="primary-btn rounded">
      Confirmar
    </button>
    <!-- Esta era la condicional que tenian antes
    *ngIf="data.type != 'LDC' ||  data.approbvalStatus =='requestLevelTwo'"
*ngIf="data.type != 'LDC' ||  data.approbvalStatus =='requestLevelTwo'" -->
  </div>

  <!-- RAS -->
  <!-- <div
    *ngIf="data.type == 'LDC' && data.approbvalStatus == 'requestLevelOne'"
    class="content"
  >
    <h3 class="title">Análisis del Caso</h3>
    <form class="formulario">
      <mat-form-field class="matform" appearance="outline">
        <mat-label>Número de Referencia del Reporte</mat-label>
        <input type="text" matInput />
      </mat-form-field>

      <mat-form-field class="matform" appearance="outline">
        <mat-label>Observaciones</mat-label>
        <textarea matInput></textarea>
      </mat-form-field>

      <div class="buttons">
        <button
          mat-raised-button
          (click)="close(false)"
          class="cancel-btn rounded"
        >
          Rechazar Reporte
        </button>
        <button
          mat-raised-button
          (click)="close(true)"
          class="primary-btn rounded"
        >
          Aprobar Reporte
        </button>
      </div>
    </form>
  </div> -->
</div>